export const verification = {
    title: '身份验证',
    infomation: '个人信息。',
    content:
        '请确保输入的所有信息与您的身份证明相符。 按下确认后，您无法更改信息。',
    selectInfo: '选择身份证明文件的类型。',
    passport: '护照',
    identity: '公民身份证',
    countries: '选择国家',
    numberCmt: '公民身份号码',
    numberPassport: '护照号码',
    identityTitle: '身份证照片',
    passportTitle: '护照照片',
    line1: '请确保您的证件照片清晰详细。',
    line2: '请使用大小不超过 10MB 的图片',
    line3: '请使用 JPG、JPEG、PNG 格式的图片。',
    label1: '足够详细。',
    label2: '不得缺失',
    label3: '不模糊',
    label4: '无阴影',
    contentBefore: '正面上传',
    contentAfter: '背面上传',
    imageBefore: '正面',
    imageAfter: '背面',
    passportLabel: '护照照片',
    portraitLabel: '照片',
    back: '返回',
    nextStep: '继续',
    portraitTitle: '自拍照片。',
    portraitContent1:
        '请不要戴帽子、眼镜或使用过滤器，光线充足。',
    portraitContent2: '请使用大小不超过 10MB 的图片。 ',
    portraitContent3: '请使用 JPG、JPEG、PNG 格式的图片。',
    portraitContent4Cccd:
        '拍一张清晰的脸部照片，手持您的公民身份证和一张写有拍摄日期的纸，并写上 "ste.sbgroup.finance".',
    portraitContent4Passport:
        '拍一张清晰的脸部照片，手持您的护照和一张写有拍摄日期的纸，并写上 "ste.sbgroup.finance".',
    contentPortrait: '上传图片',
    completeTitle: '感谢您帮助我们验证身份！',
    completeContent: '请等待管理员验证后再购买',
    gotoHome: '进入首页',
    requiredImage: '不能为空',
    required: {
        passportLabel: '护照照片不能为空',
        portraitLabel: '肖像不能为空',
        imageBefore: '前面不能为空',
        imageAfter: '背面不能为空',
    },
    validateMaxSizeImage: '只上传小于 10MB 的文件',
    validateMinSizeImage: '图片大小必须至少为 10kb',
    validateImage: '只能上传jpg,png.jpeg图片',
    placeholderCmt: '示例: B2412111',
};
